module.exports = {
  home: {
    home: '首页',
    node: '节点',
    docs: '文档',
    FUND: '基金',
    VAULTDIVIDEND: '金库分红',
    VAULT: '金库',
    launchDapp: "启动 DAPP",
    welcomeFireCat:'欢迎加入火猫金融',
    evolvingEcosystem:'火猫金融是一个不断发展的创新生态系统，包括有着高 APR 的去中心化金融的 NFT 挖矿平台，金库协议，去中心化交易所等更多产品和服务。',
    whatFireCat:'什么是火猫金融？',
    nextNft:'下一代 NFT',
    multiBlockchain:'多链使用',
    endlessPossibilites:'无限可能',
    Vaults:'金库',
    bestStrategies:'最佳策略',
    highAPR:'高年化收益',
    highLiquidity:'高流动性',
    nextDEFImining:'新一代 DEFI 挖矿',
    combination:'DEFI 和 NFT 的结合',
    continualReward:'持续稳定的奖励',
    dex:'去中心化交易所',
    swapAnything:'交换任何东西',
    earnTradingFees:'赚取交易手续费',
    noRegistration:'无需注册',
    communityGovernance:'社区治理',
    proposal:'提案',
    voting:'投票',
    earnReward:'邀请用户在 FireCat Finance 质押赚取奖励',
    roadmap:'路线图',
    phase:'阶段',
    websiteLaunch:'官网上线',
    smartContractDeployment:'智能合约开发',
    fairTokenLaunch:'代币发售',
    airdropEvent:'空投活动',
    whitepaperRelease:'白皮书公布',
    nftOnline:'NFT 上线',
    firecatNFTonline:'Firecat NFT 上线',
    vaultsProtocolOnline:'金库协议上线',
    nftLevelUpOnline:'NFT 升级功能上线',
    moreNFTonline:'更多 NFT 的推出',
    decentralizedDAOVotingSystem:'去中心化 DAO 治理系统',
    decentralizedExchange:'去中心化交易所',
    moreVaults:'更多金库',
    supportMoreBlockChain:'支持更多链',
    commingSoon: '敬请期待',
    back: '返回',
    register: '注册',
    referrerAddress: '推荐人地址',
    connectWallet: '链接钱包',
    pleaseEnter: '请输入……',
    neterror: '网络错误',
    confirm: '确认',
    registrationSucceeded:'注册成功',
    pleaseRevise: '你的推荐人地址错误。请修改并提交!',
    loading: '确认中',
    registered: '已注册',
    myReferrals: '我的推荐人',
    viewSubordinates: '查看下级',
    myAddress: '我的地址',
    numberOfSubordinates: '下级的人数',
  }
}
